import React from 'react';
import { LabelField, ImageField } from '../../components/Admin';

export default class Home extends React.Component {
	render(){
		var { website, onChangeProp, onChangeImage } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.title} onChange={onChangeProp} prop="title" name="Frase principal" info="40 caracteres" />
				<LabelField defaultValue={website.subtitle} onChange={onChangeProp} prop="subtitle" name="Descripción" info="110 caracteres" rows={3} />
				<ImageField
					defaultValue={website.headerImage}
					onChange={onChangeImage} prop="headerImageId"
					name="Imagen de fondo"
					info="Al menos 1280x720" />
			</div>
		)
	}
}
